
export const AssignSuperAdminDataTableColumns = [
  {
    label: "Company Logo",
    excelName: "Company Logo",
    // columnWidth: "200px",
    isSort: false,
    id: "logo",
  },
  {
    label: "Company Name",
    excelName: "Company Name",
    // columnWidth: "200px",
    isSort: false,
    id: "name",
  },
  {
    label: "Action",
    isSort: false,
    id: "ActionToEditAndDelete",
    isIcon: true,
    cellAlign: "center",
    columnWidth: "250px",
    headerAlign: "center",
  },
];
